import DocumentWrapper from './DocumentWrapper';

export default DocumentWrapper;
